import React from 'react';
import { Spinner, ProgressBar } from 'react-bootstrap';
import useBorradoProgreso from 'akasia-components/licencia/LicenciasVencidasDataBorrado/useBorradoProgreso';

const NavbarProgresoBorrado = () => {
    const { progresoBorrado, setProgresoBorrado } = useBorradoProgreso();

    if (!progresoBorrado?.enProgreso && !progresoBorrado?.completado) {
        return null;
    }

    const total = progresoBorrado.totalEmpresas || 0;
    const procesadas = progresoBorrado.procesadas || 0;
    const porcentaje = total > 0 ? Math.round((procesadas / total) * 100) : 0;

    return (
        <div 
            className="d-flex align-items-center gap-2 px-2 px-sm-3 py-1 me-2 rounded-3 border border-300 bg-100 shadow-sm user-select-none"
            style={{ cursor: 'pointer', maxWidth: '340px' }}
            onClick={() => setProgresoBorrado(prev => ({ ...prev, show: true }))}
            title="Clic para ver detalle de borrado de bases de datos"
        >
            {progresoBorrado.enProgreso ? (
                <Spinner 
                    animation="border" 
                    size="sm" 
                    variant="primary" 
                    style={{ width: '13px', height: '13px', borderWidth: '2px' }} 
                />
            ) : (
                <i className="fas fa-check-circle text-success fs--1"></i>
            )}

            <div className="d-flex flex-column" style={{ minWidth: '135px' }}>
                <div className="d-flex justify-content-between align-items-center fs--2 mb-1">
                    <span className="fw-semi-bold text-900 text-truncate">
                        {progresoBorrado.enProgreso ? 'Borrando empresas' : 'Borrado finalizado'}
                    </span>
                    <span className="fw-bold text-primary ms-1">
                        {progresoBorrado.enProgreso ? `${porcentaje}%` : `${procesadas}/${total}`}
                    </span>
                </div>
                <ProgressBar 
                    animated={progresoBorrado.enProgreso} 
                    striped={progresoBorrado.enProgreso}
                    variant={progresoBorrado.fallidas > 0 ? "warning" : "primary"} 
                    now={total > 0 ? porcentaje : (progresoBorrado.enProgreso ? 15 : 100)} 
                    style={{ height: '4px', borderRadius: '2px' }} 
                />
            </div>

            <i className="fas fa-external-link-alt text-400 fs--2 ms-1"></i>

            {progresoBorrado.completado && !progresoBorrado.enProgreso && (
                <button
                    type="button"
                    className="btn btn-link btn-sm p-0 ms-1 text-400 hover-text-danger"
                    style={{ textDecoration: 'none', lineHeight: 1 }}
                    onClick={(e) => {
                        e.stopPropagation();
                        setProgresoBorrado(prev => ({ ...prev, completado: false }));
                    }}
                    title="Cerrar notificación"
                >
                    <i className="fas fa-times fs--2"></i>
                </button>
            )}
        </div>
    );
};

export default NavbarProgresoBorrado;
